const TOKEN_KEY = "authToken";


export const fakeInitDataRaw = "query_id=AAE8c_wmAAAAADxz_CYAJGIA&user=%7B%22id%22%3A654078780%2C%22first_name%22%3A%22Musoxon%22%2C%22last_name%22%3A%22Abdulkhamidov%22%2C%22username%22%3A%22ssmn_31_07%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2Fvn9xc8vBH0XLwFpY-XIqJjuH7WB9GDf8y2WOdnK7zqI.svg%22%7D&auth_date=1777892671&signature=mW7RPPcUIDcRvwJ8tF3oGt-o9rIrYynkbNYtoFeRH7ipoy9bGgl2DpHLTrI9CgxisJcUz-WjDg7PA-llW8StAg&hash=add29874f38b1d0f294555a314e6b9244c667a8b32817b37569ef064937fcecc"

/** JWT payload'dan `exp` (Unix seconds) ni o'qiydi */
function parseJwtExp(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return typeof payload.exp === "number" ? payload.exp : null;
  } catch {
    return null;
  }
}

export function getToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    // sessionStorage yo'q (private mode / disabled) — jimgina o'tkazib yuboramiz
  }
}

export function clearToken(): void {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    // sessionStorage yo'q — jimgina o'tkazib yuboramiz
  }
}

/**
 * Token mavjud va 60 soniyadan ko'proq vaqt qolganda true qaytaradi.
 * Bu shartni bajarilsa, qayta login kerak emas.
 */
export function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  const exp = parseJwtExp(token);
  if (exp === null) return false;
  return Date.now() / 1000 < exp - 60;
}
